import { useEffect } from 'react'
import { getDateRangeForMode, type OutputMode } from '../components/DateFilterBar'

// Modes the useYearDates pages understand. Page-specific modes ('last_week',
// 'yesterday') have no counterpart there, so they are not mirrored.
const SHARED_DATE_FILTER_MODES: ReadonlyArray<string> = [
  'year_to_date', 'month_to_date', 'last_month', 'last_year', 'custom',
]

/**
 * Mirror the shared period choice (bp:filter:outputMode + custom dates) into
 * the bp:filter:startDate/endDate session keys that useYearDates reads.
 *
 * Every page that picks a period without useYearDates must call this. Without
 * it the next page shows that page's period choice but queries whatever range
 * was stored before (bilpriser-backend#307).
 */
export function useMirrorSharedDates(
  outputMode: string,
  customStartDate: string,
  customEndDate: string,
  maxDataDate: string | null,
): void {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!SHARED_DATE_FILTER_MODES.includes(outputMode)) return

    let sd: string | null = null
    let ed: string | null = null
    if (outputMode === 'custom') {
      if (!customStartDate || !customEndDate) return
      sd = customStartDate
      ed = customEndDate
    } else {
      const maxDate = maxDataDate ? new Date(maxDataDate + 'T12:00:00') : null
      const range = getDateRangeForMode(outputMode as OutputMode, maxDate)
      sd = range.startDate
      ed = range.endDate
    }
    try {
      window.sessionStorage.setItem('bp:filter:startDate', JSON.stringify(new Date(sd).toISOString()))
      window.sessionStorage.setItem('bp:filter:endDate', JSON.stringify(new Date(ed).toISOString()))
    } catch {
      // ignore quota / privacy-mode errors
    }
  }, [outputMode, customStartDate, customEndDate, maxDataDate])
}
